import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { subdivide } from "@thi.ng/geom-subdiv-curve";
import { Polygon } from "../api/polygon";
import { Polyline } from "../api/polyline";
import { copyAttribs } from "../internal/copy-attribs";
import { dispatch } from "../internal/dispatch";
export const subdivCurve = defmulti(dispatch);
subdivCurve.addAll({
    [Type.POLYGON]: ($, kernel, iter = 1) => new Polygon(subdivide($.points, kernel, iter), copyAttribs($)),
    [Type.POLYLINE]: ($, kernel, iter = 1) => new Polyline(subdivide($.points, kernel, iter), copyAttribs($)),
});
